import UiState from '../constants/ui-state';
import UiStateStore from './stores/ui-state-store';

const loadingInterlude = 500;

export default class FormUiState {

    static setWaiting(componentId) {
        UiStateStore.update(componentId, (model) => {
            model.form.uiState = UiState.waiting;
        });
    }

    static setReady(componentId) {
        if (UiStateStore.getModel(componentId).form.uiState === UiState.waiting) {
            setTimeout(() => FormUiState._setReadyState(componentId), loadingInterlude);
            return;
        }

        if (UiStateStore.getModel(componentId).form.uiState === UiState.ready) {
            return;
        }

        FormUiState._setReadyState(componentId);
    }

    static setDisposed(componentId) {
        UiStateStore.update(componentId, (model) => {
            model.form.uiState = UiState.disposed;
        });
    }

    static _setReadyState(componentId) {
        UiStateStore.update(componentId, (model) => {
            model.form.uiState = UiState.ready;
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/logic/form-ui-state.js
 **/